import { toast } from 'react-toastify';
import instance, { gatewayInstance } from '../../../services/api';
import {
  SET_CATEGORY_PRODUCTS_V2,
  SET_LOADING,
  SET_PAGINATION_V2,
  SET_MENUS_V2,
  SET_LINK_PROVIDER_LOADING,
  SET_LINK_PROVIDER_VISIBILITY,
  SET_CHECKED_PROVIDER,
  SET_PROVIDER_DOORDASH_LOADING,
  SET_PROVIDER_GRUBHUB_LOADING,
  SET_LINK_PROVIDER,
  SET_LOADING_PRODUCT,
  SET_PROVIDER_DOORDASH_BTN_HIDDEN,
  SET_FORM_PRODUCT,
} from '../types';
import { getProductById, getProductsAll } from './products';
import { buildMenuExport } from 'utils/menuExport';

export const getMenusV2 =
  (loadCategories = true) =>
  (dispatch, getState) => {
    const {
      menu: { menus },
      providers: {
        providerConfig: { providers },
      },
    } = getState();
    dispatch({ type: SET_LOADING, payload: true });
    dispatch({ type: SET_LOADING_PRODUCT, payload: true });

    return instance
      .get('/menu/v2')
      .then(({ data: { data } }) => {
        // Helper function to set default checked providers
        const setDefaultCheckedProviders = (connectedProviders) => {
          const defaultCheckedProviders = Object.keys(connectedProviders)
            .filter((item) => item !== 'main')
            .map((item) => ({ [item]: connectedProviders[item] }));
          localStorage.setItem(
            SET_CHECKED_PROVIDER,
            JSON.stringify(defaultCheckedProviders)
          );
        };

        // If categories don't need to be loaded, return early
        if (!loadCategories) {
          dispatch({ type: SET_MENUS_V2, payload: data });
          setDefaultCheckedProviders(data.connectedProviders);
          dispatch({ type: SET_LOADING_PRODUCT, payload: false });
          return data;
        }

        // Load categories with products
        const categoryPromises = (data.categories || []).map((catData) => {
          const _id = catData?._id;
          return instance
            .get(`/categories/v2/${_id}?sortDirection=ASC&products=true`)
            .then((res) => {
              const { products } = res?.data?.data || [];
              const targetCategoryIndex = data.categories?.findIndex(
                (cat) => cat._id === _id
              );

              if (targetCategoryIndex !== -1 && targetCategoryIndex >= 0) {
                data.categories[targetCategoryIndex].products = products;
                data.categories[targetCategoryIndex].productsCount =
                  products.length;
              }
            })
            .catch((err) => {
              // Log error but continue with other categories
              console.error(`Failed to load category ${_id}:`, err);
            });
        });

        return Promise.allSettled(categoryPromises).then(() => {
          dispatch({ type: SET_MENUS_V2, payload: data });
          setDefaultCheckedProviders(data.connectedProviders);
          dispatch({ type: SET_LOADING_PRODUCT, payload: false });
          return data;
        });
      })
      .catch((err) => {
        dispatch({ type: SET_LOADING_PRODUCT, payload: false });
        return Promise.reject(err);
      })
      .finally(() => {
        dispatch({ type: SET_LOADING, payload: false });
      });
  };

export const getCategoryProductsV2ByCategoryId =
  ({ selectedCategory, selectedMenu }) =>
  (dispatch, getState) => {
    const { menu } = getState();
    const skip = 0;
    const limit = 1000;
    const { menus } = menu;
    const categoryData = {
      ...menus,
    };
    if (!selectedCategory || !selectedMenu || !categoryData) {
      return;
    }
    if (!categoryData?.products?.length) {
      dispatch({ type: SET_LOADING, payload: true });
    }
    return instance
      .get(
        `/categories/v2/${selectedCategory}?skip=${skip}&limit=${limit}&sortDirection=ASC&products=true`
      )
      .then(({ data: { data } }) => {
        categoryData[selectedMenu].categories[selectedCategory] &&
          (categoryData[selectedMenu].categories[selectedCategory].products =
            data?.products);
        dispatch({
          type: SET_PAGINATION_V2,
          payload: {
            count: Math.ceil(data.count / limit),
          },
        });
        dispatch({
          type: SET_CATEGORY_PRODUCTS_V2,
          payload: { baseData: categoryData },
        });
        return data;
      })
      .finally(() => dispatch({ type: SET_LOADING, payload: false }))
      .catch((err) => {
        return Promise.reject(err);
      });
  };

// Link menu with provider

export const menuLinkProvider = (body) => (dispatch) => {
  dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: true });
  return instance
    .post(`/menu/push`, body)
    .then(({ data: { data } }) => {
      dispatch({ type: SET_LINK_PROVIDER_VISIBILITY, payload: false });
      // Refresh menu data after linking
      dispatch(getMenusV2(false));
    })
    .finally(() =>
      dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: false })
    );
};

export const categoryLinkProvider = (body) => (dispatch) => {
  dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: true });
  return instance
    .post(`/menu/category/push`, body)
    .then(({ data: { data } }) => {
      dispatch({ type: SET_LINK_PROVIDER_VISIBILITY, payload: false });
      // Refresh menu data after linking
      dispatch(getMenusV2(false));
    })
    .finally(() =>
      dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: false })
    );
};

export const productLinkProvider = (body) => (dispatch) => {
  dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: true });
  return instance
    .post(`/menu/product/push`, body)
    .then(({ data: { data } }) => {
      dispatch(getProductsAll(5, 0));
      dispatch({ type: SET_LINK_PROVIDER_VISIBILITY, payload: false });
      dispatch(getProductById(body.id));
      // Refresh menu data after linking
      dispatch(getMenusV2(false));
    })
    .finally(() =>
      dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: false })
    );
};
export const linkProviderTarget =
  (sendDataProvider = []) =>
  async (dispatch, getState) => {
    const {
      menu: { linkProvider },
    } = getState();
    const { target, id, connectedProviders } = linkProvider;
    const providers = Object.keys(connectedProviders)
      .filter((provider) => provider !== 'main')
      .map((item) => ({
        provider: item,
        isLinked: connectedProviders[item],
      }));

    try {
      if (target === 'menu') {
        await dispatch(menuLinkProvider({ providers }));
        if (sendDataProvider.length) {
          for (const item of sendDataProvider) {
            await dispatch(uploadBulk(item));
          }
        }
        window.location.href = '/menu/overview';
      } else if (target === 'category') {
        await dispatch(categoryLinkProvider({ id, providers }));
      } else {
        await dispatch(productLinkProvider({ id, providers }));
      }
    } catch (error) {
      console.error('Error linking providers: ', error);
    }
  };

export const setMenuFromSocket = (data) => (dispatch, getState) => {
  dispatch({ type: SET_MENUS_V2, payload: data });
};

export const updateBulk = () => (dispatch, getState) => {
  const {
    menu: { menu, formProduct },
  } = getState();

  dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: true });
  return instance
    .post(`menu/bulk`)
    .then(() => {
      const markSaved = (item) => {
        if (!item) return;
        item.bulkInfo = { ...(item.bulkInfo || {}), isSaved: true };
      };

      markSaved(menu);
      (menu.modifiersAll || []).forEach(markSaved);
      (menu.categories || []).forEach((catItem) => {
        markSaved(catItem);
        (catItem.products || []).forEach(markSaved);
      });

      // Send only bulkInfo so SET_MENUS_V2 does not copy stale category
      // products over the flags we just marked saved. Nested isSaved was
      // updated in place; a new bulkInfo object forces the header to re-render.
      dispatch({
        type: SET_MENUS_V2,
        payload: {
          bulkInfo: { ...(menu.bulkInfo || {}), isSaved: true },
        },
      });

      // Keep the currently open product in sync so the bulk-update button
      // reflects that everything is saved (otherwise it stays enabled).
      if (formProduct?._id) {
        dispatch({
          type: SET_FORM_PRODUCT,
          payload: {
            ...formProduct,
            bulkInfo: { ...(formProduct.bulkInfo || {}), isSaved: true },
          },
        });
      }
    })
    .finally(() => {
      dispatch({ type: SET_LOADING, payload: false });
      dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: false });
    });
};

export const uploadBulk = (body) => (dispatch) => {
  dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: true });
  return instance.post(`menu/bulk/upload`, body).finally(() => {
    dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: false });
  });
};

export const doordashMapProvider = (body) => (dispatch) => {
  dispatch({ type: SET_PROVIDER_DOORDASH_LOADING, payload: true });
  return instance
    .post(`/menu/bulk/map`, body)
    .then((response) => {
      dispatch({ type: SET_PROVIDER_DOORDASH_LOADING, payload: false });
      dispatch({ type: SET_PROVIDER_DOORDASH_BTN_HIDDEN, payload: true });
    })
    .catch((err) => {
      dispatch({ type: SET_PROVIDER_DOORDASH_BTN_HIDDEN, payload: false });
      dispatch({ type: SET_PROVIDER_DOORDASH_LOADING, payload: false });
    })
    .finally(() => {
      dispatch({ type: SET_PROVIDER_DOORDASH_LOADING, payload: false });
    });
};

export const grubHubMapProvider = (body) => (dispatch) => {
  dispatch({ type: SET_PROVIDER_GRUBHUB_LOADING, payload: true });
  return instance
    .post(`/menu/bulk/map`, body)
    .then((response) => {
      dispatch({ type: SET_PROVIDER_GRUBHUB_LOADING, payload: false });
    })
    .finally(() => {
      dispatch({ type: SET_PROVIDER_GRUBHUB_LOADING, payload: false });
    });
};

export const getDoordashMenuTargetData = () => (dispatch, getState) => {
  const {
    business: { currentBusiness },
    menu: { linkProvider, formProduct },
  } = getState();
  dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: true });

  const type = linkProvider.target === 'item' ? 'product' : linkProvider.target;
  let path =
    type === 'product'
      ? `category/${
          formProduct?.category?._id || formProduct?.category
        }/${type}`
      : `${type}/${currentBusiness.restaurantMailbox}`;

  return gatewayInstance
    .get(`doordash-menu/${path}`)
    .then((res) => {
      // const filteredList = res.data.data.filter((item) => {
      //   if (!item.mappedData.length) return false;
      //   return item.mappedData.every((mappedDataId) => mappedDataId.nativeId === linkProvider.targetData._id);
      // });

      const filteredList = res.data.data.filter(
        (item) =>
          !item.mappedData.length ||
          !item.mappedData.some(
            (mappedDataId) =>
              mappedDataId.nativeId !== linkProvider.targetData._id
          )
      );

      dispatch({
        type: SET_LINK_PROVIDER,
        payload: {
          doordashTargetList: filteredList,
        },
      });

      // dispatch(updateCategory(res.data.data._id));
      return res.data.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    })
    .finally(() => {
      dispatch({ type: SET_LINK_PROVIDER_LOADING, payload: false });
    });
};

export const mapTargetToDoordash =
  (selectedItems, initialSelected, showOnlyOneMapping) =>
  (dispatch, getState) => {
    const {
      business: { currentBusiness },
      menu: {
        linkProvider: { targetData, target, doordashTargetList },
        menu,
      },
      providers: {
        providerConfig: { provider },
      },
    } = getState();
    const array = [];
    const externalMenuId = doordashTargetList[0]?.externalMenuId || '';
    const restaurantMailbox = currentBusiness.restaurantMailbox;
    Object.keys(selectedItems).forEach((key) => {
      const { value } = selectedItems[key];
      if (targetData.isOnePrice === false) {
        const dataModel = {
          nativeId: targetData._id,
          externalId: value.externalId,
          externalMenuId: value.externalMenuId,
          type: target === 'item' ? 'product' : target,
          restaurantMailbox: value.restaurantMailbox,
          nativeSizeTypeOptionId: key,
          externalCategoryId: value.externalParentId,
        };
        if (showOnlyOneMapping) {
          delete dataModel.nativeSizeTypeOptionId;
        }
        if (value.nativeCategoryId) {
          dataModel.nativeCategoryId = value.nativeCategoryId;
        }
        if (initialSelected[key]?.value?.externalId !== value.externalId) {
          if (value !== 'new') {
            array.push(dataModel);
          }

          if (
            initialSelected[key]?.value?.externalId &&
            initialSelected[key]?.value.mappedData.length
          ) {
            const mappedDataModel = initialSelected[key]?.value.mappedData.find(
              (mappedDataItem) => mappedDataItem.nativeId === targetData._id
            );
            if (mappedDataModel) {
              delete mappedDataModel.externalId;
              array.push(mappedDataModel);
            }
          }
        }
      } else {
        const dataModel = {
          nativeId: targetData._id,
          externalId: value.externalId,
          externalMenuId: value.externalMenuId,
          type: target === 'item' ? 'product' : target,
          restaurantMailbox: value.restaurantMailbox,
        };
        if (target === 'item') {
          dataModel.externalCategoryId = value.externalParentId;
          if (value.nativeCategoryId) {
            dataModel.nativeCategoryId = value.nativeCategoryId;
          }
        }

        if (initialSelected[key]?.value?.externalId !== value.externalId) {
          if (value !== 'new') {
            array.push(dataModel);
          }

          if (
            initialSelected[key]?.value?.externalId &&
            initialSelected[key]?.value.mappedData.length
          ) {
            const mappedDataModel = initialSelected[key]?.value.mappedData.find(
              (mappedDataItem) => mappedDataItem.nativeId === targetData._id
            );
            if (mappedDataModel) {
              if (value.nativeCategoryId && target === 'item') {
                mappedDataModel.nativeCategoryId = value.nativeCategoryId;
              }
              delete mappedDataModel.externalId;
              array.push(mappedDataModel);
            }
          }
        }
      }
    });
    array.map((item) => {
      item.externalMenuId = externalMenuId;
      item.restaurantMailbox = restaurantMailbox;
      item.nativeMenuId = menu?._id;
      return item;
    });

    return gatewayInstance
      .put(`doordash-menu/mapping/bulk/crud`, array)
      .then((response) => {
        const providerSrv = provider?.doordash?.srv || 'doordash';
        targetData.connectedProviders[providerSrv] = true;
      })
      .then(() => {
        dispatch(getDoordashMenuTargetData());
      });
  };

export const menuInitialSync = () => (dispatch) => {
  dispatch({ type: SET_PROVIDER_DOORDASH_LOADING, payload: true });
  let mapBodyDoorDash = {
    provider: 'doordash',
    action: 'sync',
    isLinked: true,
  };
  return instance
    .post(`/menu/initial/push`, mapBodyDoorDash)
    .then(() => {
      dispatch({ type: SET_PROVIDER_DOORDASH_LOADING, payload: false });
      dispatch({ type: SET_PROVIDER_DOORDASH_BTN_HIDDEN, payload: true });
    })
    .catch((err) => {
      dispatch({ type: SET_PROVIDER_DOORDASH_BTN_HIDDEN, payload: false });
      dispatch({ type: SET_PROVIDER_DOORDASH_LOADING, payload: false });
    })
    .finally(() => {
      dispatch({ type: SET_PROVIDER_DOORDASH_LOADING, payload: false });
    });
};

export const addManualDoordashUpdate = (body) => () => {
  try {
    return instance.post('/menu/manual-update', body);
  } catch (err) {
    return Promise.reject(err);
  }
};

const MENU_DOWNLOAD_SUCCESS = 'Menu successfully downloaded';
const MENU_DOWNLOAD_ERROR = 'Failed to download menu.';

const isFailedMenuDownload = (payload) => {
  if (!payload) {
    return false;
  }

  const details =
    payload.data && typeof payload.data === 'object' ? payload.data : {};
  const success = payload.success ?? details.success;
  const error = payload.error ?? details.error;
  const status = payload.status ?? details.status;

  if (success === false || Boolean(error) || status === false) {
    return true;
  }

  if (typeof status === 'string') {
    const normalized = status.toUpperCase();
    if (['ERROR', 'FAIL', 'FAILED', 'FAILURE'].includes(normalized)) {
      return true;
    }
  }

  const message = String(payload.message || details.message || '');
  return /fail|error/i.test(message) && !/success/i.test(message);
};

const getMenuDownloadErrorMessage = (payload) => {
  const message = payload?.data?.message || payload?.message;
  if (message && /fail|error/i.test(message) && !/success/i.test(message)) {
    return message;
  }
  return MENU_DOWNLOAD_ERROR;
};

export const downloadDoordashMenu = () => async () => {
  try {
    const response = await instance.post(
      '/providers/menu/download',
      { provider: 'doordash' },
      { skipSuccessToast: true, skipErrorToast: true }
    );

    if (isFailedMenuDownload(response?.data)) {
      toast.error(getMenuDownloadErrorMessage(response?.data));
      return Promise.reject(new Error(MENU_DOWNLOAD_ERROR));
    }

    toast.success(response?.data?.message || MENU_DOWNLOAD_SUCCESS);
    return response;
  } catch (err) {
    toast.error(MENU_DOWNLOAD_ERROR);
    return Promise.reject(err);
  }
};

// ==================== MENU IMPORT / EMPTY ====================
// POST {API}/api01/menu/import  -> { businessUuid, menu }
export const importMenuV2 = (businessUuid, menu) => async () => {
  try {
    const response = await instance.post('/menu/import', {
      businessUuid,
      menu,
    });
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

// POST {API}/api01/menu/get-provider-menu -> { provider: 'main' }
// Resolves with the `menu` body accepted by importMenuV2.
export const exportMenuV2 = () => async () => {
  const {
    data: { data: menu },
  } = await instance.post('/menu/get-provider-menu', { provider: 'main' });
  return buildMenuExport(menu);
};

// POST {API}/api01/menu/empty/history -> { ids, businessUuid }
export const emptyMenuHistoryV2 = (ids, businessUuid) => async () => {
  try {
    const response = await instance.post('/menu/empty/history', {
      ids,
      businessUuid,
    });
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getCurrentMenuId = () => async () => {
  const {
    data: { data },
  } = await instance.get('/menu/v2');
  if (!data?._id) {
    throw new Error('Menu not found for the current business');
  }
  return data._id;
};

// Lightweight version to get just menu metadata without fetching all categories/products
export const getMenuMetadata = () => async (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  return instance
    .get('/menu/v2')
    .then(({ data: { data } }) => {
      // Only store the menu metadata (no categories/products)
      const menuMetadata = {
        _id: data._id,
        name: data.name,
        description: data.description,
        // Add other metadata fields as needed
      };
      dispatch({ type: SET_MENUS_V2, payload: menuMetadata });
      dispatch({ type: SET_LOADING, payload: false });
      return menuMetadata;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING, payload: false });
      return Promise.reject(err);
    });
};
